import _ from 'lodash';
import LocationHoldsController from './components/location_holds/location_holds.controller';

class BranchManagementController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService, $translate, $location, Modal, DataCounter, $q, HoldService,
    HoldLocationService, $rootScope, UsersService, CommonLayoutService, $window) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.$location = $location;
    this.HoldLocationService = HoldLocationService;
    this.HoldService = HoldService;
    this.Modal = Modal;
    this.DataCounter = DataCounter
    this.holdServiceData = []
    this.itemHoldServiceData = []
    this.$rootScope = $rootScope
    this.currentBranch = User.getUser().branchId;
    this.UsersService = UsersService;
    this.CommonLayoutService = CommonLayoutService;
    this.userInfo = User.getUser();
    this.$window = $window;

    this.tabConfig = {
      'branch_mgmt_routes': {
        title: 'branch_mgmt.routes.title',
        state: 'branchManagement.routes'
      },
      'branch_mgmt_locations': {
        title: 'branch_mgmt.locations.title',
        state: 'branchManagement.locations'
      },
      'branch_mgmt_items': {
        title: 'branch_mgmt.items.title',
        state: 'branchManagement.items'
      },
      'branch_mgmt_tankers': {
        title: 'branch_mgmt.tankers.title',
        state: 'branchManagement.tankers'
      },
      'branch_mgmt_bagouts': {
        title: 'branch_mgmt.bagouts.title',
        state: 'branchManagement.bagouts'
      },
      'branch_mgmt_orders': {
        title: 'branch_mgmt.orders.title',
        state: 'branchManagement.orders'
      },
      'branch_mgmt_item_holds': {
        title: 'branch_mgmt.item_holds.title',
        state: 'branchManagement.itemHolds'
      },
      'branch_mgmt_location_holds': {
        title: 'branch_mgmt.location_holds.title',
        state: 'branchManagement.locationHolds'
      },
      'branch_mgmt_bypass_code': {
        title: 'branch_mgmt.bypass_code.title',
        state: 'branchManagement.bypassCode'
      },
      'branch_mgmt_daily_balance_sheet': {
        title: 'branch_mgmt.daily_balance_sheet.title',
        state: 'branchManagement.dailyBalanceSheet'
      },
      'branch_mgmt_monthly_report': {
        title: 'branch_mgmt.monthly_report.title',
        state: 'branchManagement.monthlyReport'
      },
      'branch_mgmt_deleted_shipments': {
        title: 'branch_mgmt.deleted_shipments.title',
        state: 'branchManagement.deletedShipments'
      },
      'branch_mgmt_cancelled_shipments': {
        title: 'branch_mgmt.cancelled_shipments.title',
        state: 'branchManagement.cancelledShipments'
      },
      'branch_mgmt_branch_performance': {
        title: 'branch_mgmt.branch_performance.title',
        state: 'branchManagement.branchPerformance'
      },
      'branch_mgmt_final_residual_count_commit': {
        title: 'branch_mgmt.final_residual_count_commit.title',
        state: 'branchManagement.finalResidualCountCommit'
      },
      'branch_mgmt_cash_transactions': {
        title: 'branch_mgmt.cash_transactions.title',
        state: 'branchManagement.cashDeliveries'
      },
      'branch_mgmt_tnt_bypass_code': {
        title: 'branch_mgmt.tnt_bypass_code.title',
        state: 'branchManagement.tntBypassCode'
      },
      'branch_mgmt_physical_cash_count': {
        title: 'branch_mgmt.physical_cash_count.title',
        state: 'branchManagement.physicalCashCount'
      },
      'branch_mgmt_lock_open_errors': {
        title: 'branch_mgmt.lock_open_errors.title',
        state: 'branchManagement.lockOpenErrors'
      },
      'branch_mgmt_billing_approval': {
        title: 'branch_mgmt.billing_approval.title',
        state: 'branchManagement.billingApproval'
      },
      'branch_mgmt_count_variances': {
        title: 'branch_mgmt.count_variances.title',
        state: 'branchManagement.countVariances'
      },
      'branch_mgmt_restore_route_assignments': {
        title: 'branch_mgmt.restore_route_assignments.title',
        state: 'branchManagement.restoreRouteAssignments'
      },
      'branch_mgmt_stop_performance': {
        title: 'branch_mgmt.stop_performance.title',
        state: 'branchManagement.stopPerformance'
      },
      'branch_mgmt_customer_pickup_reports': {
        title: 'branch_mgmt.customer_pickup_reports.title',
        state: 'branchManagement.customerPickupReports'
      },
      'branch_mgmt_contact_request': {
        title: 'branch_mgmt.contact_request.title',
        state: 'branchManagement.contactRequest'
      },
      'branch_mgmt_import_file_view': {
        title: 'branch_mgmt.import_file_view.title',
        state: 'branchManagement.importFileView'
      },
      'branch_mgmt_stop_scheduling': {
        title: 'branch_mgmt.stop_scheduling.title',
        state: 'branchManagement.stopScheduling'
      },
      'branch_mgmt_bin_manifest': {
        title: 'branch_mgmt.bin_manifest.title',
        state: 'branchManagement.binManifest'
      },
      'branch_mgmt_deposit_reports': {
        title: 'branch_mgmt.deposit_reports.title',
        state: 'branchManagement.depositReports'
      },
      'branch_mgmt_average_daily_balance': {
        title: 'branch_mgmt.average_daily_balance.title',
        state: 'branchManagement.averageDailyBalance'
      },
      'branch_mgmt_mileage_report': {
        title: 'Mileage Report',
        state: 'branchManagement.mileageReport'
      },
    };

    this.tabs = [];
    this.$rootScope.$broadcast('routeChange', null);
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [
      'branch_mgmt',
      'branch_mgmt_routes',
      'branch_mgmt_locations',
      'branch_mgmt_items',
      'branch_mgmt_tankers',
      'branch_mgmt_bagouts',
      'branch_mgmt_orders',
      'branch_mgmt_item_holds',
      'branch_mgmt_location_holds',
      'branch_mgmt_bypass_code',
      'branch_mgmt_daily_balance_sheet',
      'branch_mgmt_monthly_report',
      'branch_mgmt_deleted_shipments',
      'branch_mgmt_cancelled_shipments',
      'branch_mgmt_branch_performance',
      'branch_mgmt_final_residual_count_commit',
      'branch_mgmt_cash_transactions',
      'branch_mgmt_tnt_bypass_code',
      'branch_mgmt_physical_cash_count',
      'branch_mgmt_lock_open_errors',
      'branch_mgmt_billing_approval',
      'branch_mgmt_count_variances',
      'branch_mgmt_restore_route_assignments',
      'branch_mgmt_stop_performance',
      'branch_mgmt_customer_pickup_reports',
      'branch_mgmt_contact_request',
      'branch_mgmt_import_file_view',
      'branch_mgmt_stop_scheduling',
      'branch_mgmt_bin_manifest',
      'branch_mgmt_deposit_reports',
      'branch_mgmt_average_daily_balance',
      'branch_mgmt_mileage_report'
    ].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};
      if (this.acl[permissionKey] && this.acl[permissionKey].length > 0) {
        this.acl[permissionKey].forEach((permission) => {
          this.hasACL[permissionKey][permission] = true;
        });
      }
    });
  }

  itemHoldSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.currentBranch
          },
          {
            field: 'status',
            condition: '=',
            data: 'ON_HOLD'
          }
        ],
        operator: 'AND'
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }


  locationSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'status',
            condition: '=',
            data: 'ON_HOLD'
          }
        ],
        operator: 'AND'
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  $onInit() {
    const itemHoldSearchObj = this.itemHoldSearchObj();
    this.validateUserPermissions();

    this.$q.all([
      this.HoldLocationService.holdLocationCount(this.currentBranch),
      this.HoldService.holdItemCount(itemHoldSearchObj),
    ])
      .then(([holdLocationsdata, itemsHoldData]) => {
        this.tabConfig.branch_mgmt_location_holds.extra = {
          LocationHoldcount: holdLocationsdata.total
        };

        this.DataCounter.setCounterForLocationHold(this.tabConfig.branch_mgmt_location_holds.extra.LocationHoldcount);

        this.$rootScope.$on('setLocationHoldCount', (evt, data) => {
          this.tabConfig.branch_mgmt_location_holds.extra = { LocationHoldcount: data.totalRecords };
          this.DataCounter.setCounterForLocationHold(this.tabConfig.branch_mgmt_location_holds.extra.LocationHoldcount);
        })

        this.tabConfig.branch_mgmt_item_holds.extra = {
          itemHoldcount: itemsHoldData.total
        };

        this.DataCounter.setCounterForItemHold(this.tabConfig.branch_mgmt_item_holds.extra.itemHoldcount);
      })
      .catch(err => {
        console.log(err);
      })
  }

  validateUserPermissions() {
    this.loading = true;
    const currentUrl = this.$location.url();
    this.UsersService.validateUserPermissions(this.userInfo.firstName, this.userInfo.lastName)
      .then((permission) => {
        if (!permission.hasTntBypassCodePermission && !this.CommonLayoutService.isAllowToAccessPages()) {
          delete this.tabConfig['branch_mgmt_tnt_bypass_code'];

          if (this.validateUserPermissionsAndState('/TNT-bypass-code')) {
            return this.$state.go('home');
          }
        }

        this.loadPermission();

        _.forEach(this.hasACL, (permissionObj, key) => {
          if (permissionObj.all) {
            const tabConfig = this.tabConfig[key];
            if (tabConfig) {
              if (tabConfig.state === 'branchManagement.binManifest') {
                tabConfig.isReact = true;
              }
              this.tabs.push(tabConfig);
            }
          }
        });

        if (currentUrl.endsWith('/branch-management') && this.tabs && this.tabs.length) {
          this.$state.go(this.tabs[0].state);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  validateUserPermissionsAndState(wordToCheck) {
    let currentStateUrl = this.$state.href(this.$state.current);
    return currentStateUrl.includes(wordToCheck);
  }

  gotoReactUrl(state, $event) {
    if (state === "branchManagement.binManifest") {
      $event.preventDefault();
      const baseUrl = this.$window.location.origin;
      const reactUrl = `${baseUrl}/v2/index.html#/bin-manifest`;
      this.$window.open(reactUrl, "_self");
    }
    if(state === "branchManagement.depositReports") {
      $event.preventDefault();
      const baseUrl = this.$window.location.origin;
      const reactUrl = `${baseUrl}/v2/index.html#/deposit-record`;
      this.$window.open(reactUrl, "_self");
    }
    if(state === "branchManagement.averageDailyBalance") {
      $event.preventDefault();
      const baseUrl = this.$window.location.origin;
      const reactUrl = `${baseUrl}/v2/index.html#/average-daily-balance`;
      this.$window.open(reactUrl, "_self");
    }
    if(state === "branchManagement.mileageReport") {
      $event.preventDefault();
      const baseUrl = this.$window.location.origin;
      const reactUrl = `${baseUrl}/v2/index.html#/mileage-report`;
      this.$window.open(reactUrl, "_self");
    }
  }
}

export default BranchManagementController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/branch_management.controller.js